import {
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"

/**
 * Column definitions shared across the warrants admin data tables. Each table
 * composes these with its own table-specific columns, keeping the common ones
 * (id, account number, status, timestamps, soft-delete flag) consistent.
 */
export const idColumn: SoDataTableHeader = {
  title: "ID",
  key: "id",
  sortable: true,
  sortKey: "id",
}

export const accountNumberColumn: SoDataTableHeader = {
  title: "Account Number",
  key: "accountNumber",
  sortable: true,
  sortKey: "account_number",
}

export const statusColumn: SoDataTableHeader = {
  title: "Status",
  key: "status",
  sortable: true,
  sortKey: "status",
}

export const createdAtColumn: SoDataTableHeader = {
  title: "Created At",
  key: "createdAt",
  type: SoDataTableColumnType.DATE_TIME,
  sortable: true,
  sortKey: "created_at",
}

export const deletedColumn: SoDataTableHeader = {
  title: "Deleted",
  key: "isDeleted",
  type: SoDataTableColumnType.YES_OR_NO,
  sortable: false,
}
